var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.254 4.42584L16.7305 2.94928C17.3712 2.30857 18.41 2.30857 19.0507 2.94928C19.6914 3.58998 19.6914 4.62877 19.0507 5.26947L6.47816 17.842C6.01557 18.3046 5.44501 18.6447 4.81803 18.8314L2.46875 19.5312L3.16856 17.182C3.35532 16.555 3.69537 15.9844 4.15796 15.5219L15.254 4.42584ZM15.254 4.42584L17.5625 6.73437",
    stroke: "#0F172A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.7f619e2bad96e68b41d8b82ae9a384fd.svg";
export { ForwardRef as ReactComponent };